import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Forward = (props: IconProps) => (
  <Icon
    width="60"
    height="40"
    viewBox="0 0 60 40"
    fill="none"
    _hover={{ '&>rect': { fill: '#C29F6B', stroke: '#C29F6B' }, '&>path': { fill: 'white' } }}
    {...props}
  >
    <rect x="-0.5" y="0.5" width="59" height="39" transform="matrix(-1 0 0 1 59 0)" fill="white" stroke="#899396" />
    <path
      d="M46.4002 20.3536C46.5954 20.1583 46.5954 19.8417 46.4002 19.6464L43.2182 16.4645C43.0229 16.2692 42.7064 16.2692 42.5111 16.4645C42.3158 16.6597 42.3158 16.9763 42.5111 17.1716L45.3395 20L42.5111 22.8284C42.3158 23.0237 42.3158 23.3403 42.5111 23.5355C42.7064 23.7308 43.0229 23.7308 43.2182 23.5355L46.4002 20.3536ZM15.349 19.5C15.0728 19.5 14.849 19.7239 14.849 20C14.849 20.2761 15.0728 20.5 15.349 20.5L15.349 19.5ZM46.0466 19.5L15.349 19.5L15.349 20.5L46.0466 20.5L46.0466 19.5Z"
      fill="black"
    />
  </Icon>
);
